module.exports = __webpack_public_path__ + "img/ic-residuosverde.34ae1bf9.png";